import RecordClassCreator from "services/record";
import moment from "moment";

export default class StatsSatisfactionRecord extends RecordClassCreator({
  type: "statsSatisfactionRecord",

  /** @memberof StatsSatisfactionRecord# */
  date: undefined,
  /** @memberof StatsSatisfactionRecord# */
  timeSeriesUnit: undefined,
  /** @memberof StatsSatisfactionRecord# */
  yes: undefined,
  /** @memberof StatsSatisfactionRecord# */
  no: undefined,
  /** @memberof StatsSatisfactionRecord# */
  comments: undefined,
  /** @memberof StatsSatisfactionRecord# */
  likertScale: undefined
}) {
  /**
   * @returns {String}
   */
  get chartAxisLabel() {
    switch (this.timeSeriesUnit) {
      case "month": return moment(this.date).format("MMM 'YY");
      case "week": return moment(this.date).format("MMM D");
      default: return moment(this.date).format("MMM D");
    }
  }

  /**
   * @returns {String}
   */
  get tooltipLabel() {
    const date = moment(this.date);

    switch (this.timeSeriesUnit) {
      case "month":
        return date.format("MMMM, YYYY");
      case "week":
        return `Week of ${date.format("MMMM D, YYYY")}`;
      default:
        return date.format("dddd, MMMM D, YYYY");
    }
  }

  /**
   * @param {Object} payload
   * @returns {ManyResourcePayload}
   */
  static resolveFetchManyResult(payload) {
    return {
      ...payload,
      data: payload.data.map(item => ({
        ...item,
        _id: item.id
      }))
    };
  }
}
